import React from "react";
import styled, { css } from "styled-components";
import { Flex } from "../../Flex";
import { Text } from "../../Text";
import { Icon } from "../../Icon";
const PageLink = styled(Text).attrs({ as: "a" }) `
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ theme: { sizes } }) => sizes[4]}px;
  height: ${({ theme: { sizes } }) => sizes[4]}px;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }

  ${({ isActive, disabled, theme: { colors: { tableColors }, }, }) => {
    if (isActive || disabled) {
        const backgroundColor = isActive ? tableColors.paginationActiveBackground : "none";
        return css `
        cursor: not-allowed;
        background-color: ${backgroundColor};
        color: ${isActive ? tableColors.paginationActiveText : tableColors.paginationText};

        svg path {
          fill: ${isActive ? tableColors.paginationActiveText : tableColors.paginationText};
        }

        &:hover {
          color: ${isActive ? tableColors.paginationActiveText : tableColors.paginationText};
          background-color: ${backgroundColor};

          svg path {
            fill: ${isActive ? tableColors.paginationActiveText : tableColors.paginationText};
          }
        }
      `;
    }
    return css `
      cursor: pointer;

      &:hover {
        color: ${tableColors.paginationHoverText};
        background-color: ${tableColors.paginationHoverBackground};
      }
    `;
}}
`;
export const calculatePageNumberRange = (pageIndex, pageCount) => {
    const lastPageIndex = pageCount - 1;
    // empty table case
    if (lastPageIndex === -1) {
        return { endIndex: 0, startIndex: 0 };
    }
    if (pageIndex <= 5) {
        return { endIndex: Math.min(9, lastPageIndex), startIndex: 0 };
    }
    if (lastPageIndex - 5 <= pageIndex) {
        return { endIndex: lastPageIndex, startIndex: Math.max(lastPageIndex - 9, 0) };
    }
    return { endIndex: pageIndex + 4, startIndex: pageIndex - 5 };
};
export const Pagination = ({ "data-testid": dataTestId = "paginationControls", canNextPage, canPreviousPage, gotoPage, nextPage, pageIndex, pageCount = 0, previousPage, }) => {
    const lastPageIndex = pageCount - 1;
    const { startIndex, endIndex } = calculatePageNumberRange(pageIndex, pageCount);
    const range = new Array(1 + endIndex - startIndex).fill(startIndex).map((v, i) => startIndex + i);
    const pageNumbers = range.map((pageNumberIndex) => (React.createElement(PageLink, { key: `gotoPage-${pageNumberIndex}`, "data-testid": `gotoPage-${pageNumberIndex}`, onClick: () => gotoPage === null || gotoPage === void 0 ? void 0 : gotoPage(pageNumberIndex), isActive: pageNumberIndex === pageIndex, p: 2 }, pageNumberIndex + 1)));
    return (React.createElement(Flex, { "data-testid": dataTestId, justifyContent: "center", alignItems: "center", m: 3 },
        React.createElement(PageLink, { "data-testid": "firstPage", key: "firstPage", p: 2, disabled: !canPreviousPage, onClick: () => gotoPage === null || gotoPage === void 0 ? void 0 : gotoPage(0) },
            React.createElement(Icon, { src: "ChevronDoubleLeft" })),
        React.createElement(PageLink, { "data-testid": "previousPage", key: "prev", p: 2, disabled: !canPreviousPage, onClick: canPreviousPage ? previousPage : undefined },
            React.createElement(Icon, { src: "ChevronLeft" })),
        pageNumbers,
        React.createElement(PageLink, { "data-testid": "nextPage", key: "next", p: 2, disabled: !canNextPage, onClick: canNextPage ? nextPage : undefined },
            React.createElement(Icon, { src: "ChevronRight" })),
        React.createElement(PageLink, { "data-testid": "lastPage", key: "lastPage", p: 2, disabled: !canNextPage, onClick: () => gotoPage === null || gotoPage === void 0 ? void 0 : gotoPage(lastPageIndex) },
            React.createElement(Icon, { src: "ChevronDoubleRight" }))));
};
